import React, { useEffect, useMemo, useState } from "react";
import { AutocompleteDropdown } from "@/components";
import { array, string, bool, func } from "prop-types";
import { isEqual } from "lodash";
import { CommonDropdownDropdownProps } from "./CommonDropdown.types";

export const CommonDropdown = (props: CommonDropdownDropdownProps) => {
  const propsDefault = {
    defaultValue: "all",
    showAll: true,
    componentLabel: "",
  };

  // Use useMemo for optionList to avoid dependency warnings
  const optionList = useMemo(() => {
    return props.options || [];
  }, [props.options]);

  // Use props directly with fallbacks to avoid state management
  const componentLabel = props.componentLabel || propsDefault.componentLabel;
  // const showAll = props.showAll ?? propsDefault.showAll;

  // // Calculate options using useMemo to avoid state management
  // const options: DropdownOption[] = useMemo(() => {
  //   return showAll ? [...optionAll, ...optionList] : optionList;
  // }, [showAll, optionAll, optionList]);

  // Calculate default selected value using useMemo
  const defaultSelectedValue = useMemo(() => {
    if (props.defaultValue) {
      return props.defaultValue;
    }
    // if (showAll) {
    //   return propsDefault.defaultValue;
    // }
    return optionList[0]?.value || "";
  }, [props.defaultValue, propsDefault.defaultValue, optionList]);

  const [selectedValue, setSelectedValue] = useState(defaultSelectedValue);

  //region React Hooks (useEffect)
  useEffect(() => {
    // Only update selectedValue when defaultSelectedValue changes and it's different
    if (defaultSelectedValue !== selectedValue) {
      // Use setTimeout to defer state update and avoid cascading renders
      setTimeout(() => {
        setSelectedValue(defaultSelectedValue);
      }, 0);
    }
  }, [defaultSelectedValue, selectedValue]);
  //endregion React Hooks (useEffect)

  const handleOnChange = (event: any) => {
    if (!isEqual(event.value, selectedValue)) {
      setSelectedValue(event.value);
    }
    if (typeof props.onChange === "function") {
      props.onChange(event);
    }
  };

  return (
    <AutocompleteDropdown
      options={optionList}
      componentLabel={componentLabel}
      defaultValue={selectedValue}
      onChange={handleOnChange}
      required={props.required}
      showAll={props.showAll}
      allPosition={props.allPosition}
    />
  );
};

CommonDropdown.propTypes = {
  options: array.isRequired,
  componentLabel: string,
  defaultValue: string,
  showAll: bool,
  onChange: func.isRequired,
  required: bool,
};
